import {
  DatePicker,
  Grid,
  TextField,
  Box,
  Button,
  CircularProgress,
  CurrencyInput,
  Select,
  MenuItem,
} from "../../../../components";
import { formatDate, unformatPrice } from "../../../../utils";
import { isCampoBloqueado, isCampoPlaca } from "../entities/campos-veiculo";

const RenderizadorCamposValues = ({
  campos,
  onChangeValor,
  disabled = false,
  onBuscarPlaca,
  buscandoPlaca = false,
}) => {
  const renderCampo = (campo) => {
    const baseProps = {
      name: campo.id.toString(),
      label: campo.label,
      disabled: disabled || isCampoBloqueado(campo),
      sx: { mb: 1 },
      required: campo.obrigatoriedade,
      fullWidth: true,
      value: campo.value || (campo.type === "date" ? null : ""),
    };

    switch (campo.type) {
      case "string": {
        const permiteBuscaPlaca = isCampoPlaca(campo) && !!onBuscarPlaca;
        return (
          <>
            <TextField
              {...baseProps}
              inputProps={
                permiteBuscaPlaca
                  ? {
                      autoCapitalize: "characters",
                      autoCorrect: "off",
                      spellCheck: false,
                      maxLength: 8,
                    }
                  : undefined
              }
              onChange={(event) =>
                onChangeValor(campo.id, event.target.value?.toUpperCase())
              }
            />
            {permiteBuscaPlaca && (
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disableElevation
                disabled={disabled || buscandoPlaca}
                onClick={onBuscarPlaca}
                startIcon={
                  buscandoPlaca ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <i
                      className="ph-bold ph-magnifying-glass"
                      style={{ fontSize: 16 }}
                    />
                  )
                }
                sx={{ minHeight: 44, mb: 1 }}
              >
                {buscandoPlaca ? "Buscando..." : "Buscar dados do veículo"}
              </Button>
            )}
          </>
        );
      }

      case "number":
        return (
          <TextField
            {...baseProps}
            type="number"
            onChange={(event) => onChangeValor(campo.id, event.target.value)}
          />
        );

      case "date":
        return (
          <DatePicker
            {...baseProps}
            format="dd/MM/yyyy"
            shrink
            onChange={(data) => {
              const isValidDate = (d) => d instanceof Date && !isNaN(d);
              if (isValidDate(data)) {
                onChangeValor(campo.id, formatDate.toSend(data));
              }
            }}
          />
        );

      case "money":
        return (
          <CurrencyInput
            {...baseProps}
            variant="outlined"
            margin="none"
            onBlur={(event) => {
              const valorFormatado = unformatPrice(event.target.value);
              onChangeValor(campo.id, valorFormatado);
            }}
          />
        );

      case "enum":
        return (
          <Select
            {...baseProps}
            onChange={(event) => onChangeValor(campo.id, event.target.value)}
          >
            {campo.values?.split(",").map((item, index) => {
              return (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        );

      default:
        return <></>;
    }
  };

  return (
    <Grid container spacing={2}>
      {campos.map((campo) => (
        <Grid item xs={12} sm={6} key={campo.id}>
          <Box p={0} width="100%">
            {renderCampo(campo)}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default RenderizadorCamposValues;
